import { useCallback } from 'react';
import buildLocaleChangeUrl from './buildLocaleChangeUrl';
import navigateTo from './navigateTo';

const INTERNATIONAL_COUNTRY_CODE = '';

function normalizeCountry(country) {
    return country || null;
}

function normalizeSelectedCountry(selectedCode) {
    return selectedCode === INTERNATIONAL_COUNTRY_CODE ? null : selectedCode;
}

function useLocaleNavigation({ locale, country, navigate = navigateTo }) {
    const currentCountry = normalizeCountry(country);

    const changeCountry = useCallback((selectedCode) => {
        const url = buildLocaleChangeUrl({
            locale,
            country: normalizeSelectedCountry(selectedCode),
            currentLocale: locale,
            currentCountry,
        });
        navigate(url);
    }, [locale, currentCountry, navigate]);

    const changeLocale = useCallback((selectedCode) => {
        const url = buildLocaleChangeUrl({
            locale: selectedCode,
            country: currentCountry,
            currentLocale: locale,
            currentCountry,
        });
        navigate(url);
    }, [locale, currentCountry, navigate]);

    return { changeCountry, changeLocale };
}

export default useLocaleNavigation;
export { INTERNATIONAL_COUNTRY_CODE };
